import { render, staticRenderFns } from "./RinvN_Total.vue?vue&type=template&id=e2234f66"
import script from "./RinvN_Total.vue?vue&type=script&lang=js"
export * from "./RinvN_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports